<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'student/index' }">
                                Siswa
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            List Siswa
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row px-3">
            <div class="col-12">
                <form v-on:submit.prevent="paginate(1, false)">
                    <div class="row mb-4 align-items-end">
                        <div class="col-xl-3 col-lg p-1" v-if="roleElligibleFilter()">
                            <label class="text-muted d-lg-flex d-none">Filter Cabang</label>
                            <select v-model="form.search.branchID" class="form-control form-control-sm">
                                <option value="">Pilih Cabang...</option>
                                <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-lg p-1">
                            <label class="text-muted d-lg-flex d-none">Search</label>
                            <input v-model="form.search.keyword" class="form-control form-control-sm" placeholder="Search..." />
                        </div>
                        <div class="col-auto p-1">
                            <button type="submit" class="btn btn-danger btn-sm px-4">
                                Search
                            </button>
                        </div>
                        <div class="ml-auto col-auto p-1 text-right" v-if="roleElligibleModified()">
                            <b-dropdown text="Upload" variant="outline-danger" size="sm" right>
                                <b-dropdown-item v-b-tooltip.hover title="Upload file psikotes siswa berdasarkan No. peserta sebagai nama file yang diupload" v-on:click="modal.file = true">
                                    Upload File Psikotes
                                </b-dropdown-item>
                                <b-dropdown-item v-b-tooltip.hover title="Upload nilai psikotes sesuai dengan template" v-on:click="modal.score = true">
                                    Upload Nilai Psikotes
                                </b-dropdown-item>
                                <b-dropdown-item v-b-tooltip.hover title="Upload data siswa sesuai dengan template" v-on:click="modal.student = true">
                                    Upload Data Siswa
                                </b-dropdown-item>
                                <b-dropdown-item v-b-tooltip.hover title="Upload data UTBK sesuai dengan template" v-on:click="modal.utbk = true">
                                    Upload UTBK
                                </b-dropdown-item>
                                <b-dropdown-item v-b-tooltip.hover title="Upload Foto Siswa" v-on:click="modal.photo = true">
                                    Upload Foto
                                </b-dropdown-item>
                            </b-dropdown>
                            <router-link v-bind:to="{name: 'student/candidate/index'}" v-b-tooltip.hover title="Daftar calon siswa baru" class="btn btn-danger btn-sm">
                                Daftar Calon Siswa Baru
                            </router-link>
                            <router-link v-bind:to="{name: 'student/add'}" v-b-tooltip.hover title="Menambahkan data siswa baru" class="btn btn-danger btn-sm">
                                Create New Siswa
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto p-1">
                            <label class="text-muted mr-3 mb-0">Filter Kelas</label>
                        </div>
                        <div class="col px-1">
                            <div v-for="grade in grades" v-bind:key="grade.id" class="form-check form-check-inline py-1">
                                <div class="custom-control custom-checkbox">
                                    <input v-model="form.search.gradeID" type="checkbox" class="custom-control-input" v-bind:value="grade.id" v-bind:id="'grade-' + grade.id" />
                                    <label class="custom-control-label" v-bind:for="'grade-' + grade.id">{{ grade.name }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-sm btn-link" v-on:click="filterShow = !filterShow">
                                Column Filtering
                            </button>
                        </div>
                    </div>
                    <transition name="fade">
                        <div class="row mt-4" v-if="filterShow">
                            <div class="col">
                                <h4 class="text-danger mb-4">Pilih atribute yang ingin ditampilkan</h4>
                                <div class="row">
                                    <div class="col-12">
                                        <!-- Section 1 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Profil Siswa
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.username" type="checkbox" class="custom-control-input" id="filter-username" />
                                                        <label class="custom-control-label" for="filter-username">Username</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.name" type="checkbox" class="custom-control-input" id="filter-name" />
                                                        <label class="custom-control-label" for="filter-name">Nama Lengkap</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.email" type="checkbox" class="custom-control-input" id="filter-email" />
                                                        <label class="custom-control-label" for="filter-email">Alamat Email</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.schoolID" type="checkbox" class="custom-control-input" id="filter-school" />
                                                        <label class="custom-control-label" for="filter-school">Asal Sekolah</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.gradeID" type="checkbox" class="custom-control-input" id="filter-grade" />
                                                        <label class="custom-control-label" for="filter-grade">Prodi Sekolah</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.btaGradeID" type="checkbox" class="custom-control-input" id="filter-bta-grade" />
                                                        <label class="custom-control-label" for="filter-bta-grade">Prodi BTA</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['tempat_lahir', 'tanggal_lahir', 'jenis_kelamin', 'alamat_rumah', 'kode_pos', 'nomor_telp_rumah', 'nomor_hp_siswa', 'kurikulum_sekolah']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!-- Section 2 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Orang Tua Siswa
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['nama_ayah', 'nomor_hp_ayah', 'email_ayah', 'pekerjaan_ayah', 'nama_ibu', 'nomor_hp_ibu', 'email_ibu', 'pekerjaan_ibu']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!-- Section 3 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Kepesertaan Siswa BTA
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.identity" disabled type="checkbox" class="custom-control-input" id="filter-identity" />
                                                        <label class="custom-control-label" for="filter-identity">No. Kepesertaan</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['nomor_formulir']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.registeredAt" type="checkbox" class="custom-control-input" id="filter-registered-at" />
                                                        <label class="custom-control-label" for="filter-registered-at">Tanggal Daftar</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.branchID" type="checkbox" class="custom-control-input" id="filter-branch-id" />
                                                        <label class="custom-control-label" for="filter-branch-id">Cabang</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.branchProgramID" type="checkbox" class="custom-control-input" id="filter-branch-program-id" />
                                                        <label class="custom-control-label" for="filter-branch-program-id">Program</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.patternID" type="checkbox" class="custom-control-input" id="filter-pattern-id" />
                                                        <label class="custom-control-label" for="filter-pattern-id">Pola</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.branchClassID" type="checkbox" class="custom-control-input" id="filter-class-id" />
                                                        <label class="custom-control-label" for="filter-class-id">Kelas</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.intensiveScheduleID" type="checkbox" class="custom-control-input" id="filter-intensive-schedule-id" />
                                                        <label class="custom-control-label" for="filter-intensive-schedule-id">Sesi Intensif</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.intensiveClassID" type="checkbox" class="custom-control-input" id="filter-intensive-class-id" />
                                                        <label class="custom-control-label" for="filter-intensive-class-id">Kelas Intensif</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.placement" type="checkbox" class="custom-control-input" id="filter-placement" />
                                                        <label class="custom-control-label" for="filter-placement">Ruang Placement test</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.payment" type="checkbox" class="custom-control-input" id="filter-payment" />
                                                        <label class="custom-control-label" for="filter-payment">Tahapan Pembayaran</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.paymentNote" type="checkbox" class="custom-control-input" id="filter-payment-note" />
                                                        <label class="custom-control-label" for="filter-payment-note">Keterangan Pembayaran</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.ukuran_jaket" type="checkbox" class="custom-control-input" id="filter-ukuran_jaket" />
                                                        <label class="custom-control-label" for="filter-ukuran_jaket">Ukuran Kaos/Jaket</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.diterima_jalur" type="checkbox" class="custom-control-input" id="filter-diterima_jalur" />
                                                        <label class="custom-control-label" for="filter-diterima_jalur">Diterima Di Jalur</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.diterima_univ" type="checkbox" class="custom-control-input" id="filter-diterima_univ" />
                                                        <label class="custom-control-label" for="filter-diterima_univ">Diterima Di Sekolah/Univ</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['diterima_prodi']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="n in 3">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns['sekolah_impian_' + n]" type="checkbox" class="custom-control-input" v-bind:id="'filter-sekolah_impian_' + n" />
                                                        <label class="custom-control-label" v-bind:for="'filter-sekolah_impian_' + n">Sekolah/ Universitas Impian {{ n }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!-- Section 4 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Kepesertaan SNMPTN
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['SNMPTN_nomor']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                                <template v-for="n in 3">
                                                    <div class="form-check form-check-inline py-1 pl-0">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="columns['SNMPTN_univ_' + n]" type="checkbox" class="custom-control-input" v-bind:id="'filter-SNMPTN_univ_' + n" />
                                                            <label class="custom-control-label" v-bind:for="'filter-SNMPTN_univ_' + n">Univ {{ n }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="form-check form-check-inline py-1 pl-0">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="columns['SNMPTN_prodi_' + n]" type="checkbox" class="custom-control-input" v-bind:id="'filter-SNMPTN_prodi_' + n" />
                                                            <label class="custom-control-label" v-bind:for="'filter-SNMPTN_prodi_' + n">Prodi {{ n }}</label>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <!-- Section 5 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Kepesertaan SBMPTN
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['SBMPTN_nomor']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                                <template v-for="n in 3">
                                                    <div class="form-check form-check-inline py-1 pl-0">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="columns['SBMPTN_univ_' + n]" type="checkbox" class="custom-control-input" v-bind:id="'filter-SBMPTN_univ_' + n" />
                                                            <label class="custom-control-label" v-bind:for="'filter-SBMPTN_univ_' + n">Univ {{ n }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="form-check form-check-inline py-1 pl-0">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="columns['SBMPTN_prodi_' + n]" type="checkbox" class="custom-control-input" v-bind:id="'filter-SBMPTN_prodi_' + n" />
                                                            <label class="custom-control-label" v-bind:for="'filter-SBMPTN_prodi_' + n">Prodi {{ n }}</label>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!-- Section 6 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Kepesertaan SIMAK UI
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['SIMAK_nomor']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="n in 7">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns['SIMAK_prodi_' + n]" type="checkbox" class="custom-control-input" v-bind:id="'filter-SIMAK_prodi_' + n" />
                                                        <label class="custom-control-label" v-bind:for="'filter-SIMAK_prodi_' + n">Prodi {{ n }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!-- Section 7 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Kepesertaan Talent Scouting
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['TS_nomor', 'TS_univ', 'TS_prodi']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Section 8 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Kepesertaan Ujian Mandiri
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <template v-for="n in 3">
                                                    <div class="form-check form-check-inline py-1 pl-0">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="columns['Mandiri_' + n + '_nomor']" type="checkbox" class="custom-control-input" v-bind:id="'filter-Mandiri_' + n + '_nomor'" />
                                                            <label class="custom-control-label" v-bind:for="'filter-Mandiri_' + n + '_nomor'">Nomor Ujian Mandiri {{ n }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="form-check form-check-inline py-1 pl-0">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="columns['Mandiri_' + n + '_univ']" type="checkbox" class="custom-control-input" v-bind:id="'filter-Mandiri_' + n + '_univ'" />
                                                            <label class="custom-control-label" v-bind:for="'filter-Mandiri_' + n + '_univ'">Universitas Ujian Mandiri {{ n }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="form-check form-check-inline py-1 pl-0">
                                                        <div class="custom-control custom-checkbox">
                                                            <input v-model="columns['Mandiri_' + n + '_prodi']" type="checkbox" class="custom-control-input" v-bind:id="'filter-Mandiri_' + n + '_prodi'" />
                                                            <label class="custom-control-label" v-bind:for="'filter-Mandiri_' + n + '_prodi'">Prodi Ujian Mandiri {{ n }}</label>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!-- Section 9 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Kepesertaan PPKB
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['PPKB_nomor', 'PPKB_univ', 'PPKB_prodi']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Section 10 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Kepesertaan IUP UGM
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['IUP_nomor', 'IUP_prodi']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-auto">
                                        <h4 class="text-danger p-2 mb-0">Jika Sudah, silakan</h4>
                                    </div>
                                    <div class="col">
                                        <button class="btn btn-danger btn-sm px-5" type="button" v-on:click="filterShow = false">Hide Column Filtering</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                    <table class="table">
                        <thead>
                            <tr class="text-danger font-weight-bold">
                                <th scope="col" v-if="columns.identity" name="identity" v-on:click="sort">
                                    No. Peserta <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.name" name="name" style="min-width: 15rem;" v-on:click="sort" class="sticky">
                                    Nama Lengkap <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.username" name="username" v-on:click="sort">
                                    Username <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.branchID" name="branchID" v-on:click="sort">
                                    Cabang <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.schoolID" name="schoolID" v-on:click="sort">
                                    Asal Sekolah <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.gradeID" name="gradeID" v-on:click="sort">
                                    Kelas Sekolah <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.btaGradeID" name="btaGradeID" v-on:click="sort">
                                    Kelas BTA <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.email" name="email" v-on:click="sort">
                                    Email <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.registeredAt" name="registeredAt" v-on:click="sort">
                                    Tanggal Daftar <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.branchProgramID" name="branchProgramID" v-on:click="sort">
                                    Program <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.patternID" name="patternID" v-on:click="sort">
                                    Pola <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.branchClassID" name="branchClassID" v-on:click="sort">
                                    Kelas <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.intensiveScheduleID" name="intensiveScheduleID" v-on:click="sort">
                                    Sesi Intensif <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.intensiveClassID" name="intensiveClassID" v-on:click="sort">
                                    Kelas Intensif <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.placement" name="placement" v-on:click="sort">
                                    Ruang Placement test <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.payment" name="payment" v-on:click="sort">
                                    Tahapan Pembayaran <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.paymentNote" name="paymentNote" v-on:click="sort">
                                    Keterangan Pembayaran <i class="fa fa-chevron-down"></i>
                                </th>

                                <th scope="col" v-for="profileLabel in profileLabels" v-if="columns[profileLabel]" v-bind:name="profileLabel" v-on:click="sort">
                                    {{ renderProfileLabel(profileLabel) }} <i class="fa fa-chevron-down"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="shadow-sm" v-for="student in students" v-bind:key="student.userID">
                                <td v-if="columns.identity">
                                    <router-link v-bind:to="{name: 'student/view', params: {id: student.userID}}" class="text-loading">{{ student.identity }}</router-link>
                                </td>
                                <td v-if="columns.name" class="sticky">
                                    <span class="text-loading" v-if="student.user">{{ student.user.name }}</span>
                                </td>
                                <td v-if="columns.username">
                                    <span class="text-loading" v-if="student.user">{{ student.user.username }}</span>
                                </td>
                                <td v-if="columns.branchID">
                                    <span class="text-loading" v-if="student.branch">{{ student.branch.name }}</span>
                                </td>
                                <td v-if="columns.schoolID">
                                    <span class="text-loading" v-if="student.school">{{ student.school.name }}</span>
                                </td>
                                <td v-if="columns.gradeID">
                                    <span class="text-loading" v-if="student.grade">{{ student.grade.name }}</span>
                                </td>
                                <td v-if="columns.btaGradeID">
                                    <span class="text-loading" v-if="student.btaGrade">{{ student.btaGrade.name }}</span>
                                </td>
                                <td v-if="columns.email">
                                    <span class="text-loading" v-if="student.user">{{ renderCheckBlank(student.user.email) }}</span>
                                </td>
                                <td v-if="columns.registeredAt">
                                    <span class="text-loading"><template v-if="student.registeredAt">{{ $moment(student.registeredAt, "YYYY-MM-DD").format('D MMMM YYYY') }}</template></span>
                                </td>
                                <td v-if="columns.branchProgramID">
                                    <template v-if="student.studentVerified && Object.keys(guessBranchProgram(student)).length">{{ guessBranchProgram(student).grade.name }} - {{ guessBranchProgram(student).programType.name }}</template>
                                </td>
                                <td v-if="columns.patternID">
                                    <template v-if="student.studentVerified && student.studentVerified.pattern">{{ student.studentVerified.pattern.periods.map(period => $moment.weekdays(period.day)).join(", ") }}</template>
                                </td>
                                <td v-if="columns.branchClassID">
                                    <template v-if="student.studentVerified && student.studentVerified.branchClass">{{ student.studentVerified.branchClass.name }}</template>
                                </td>
                                <td v-if="columns.intensiveScheduleID">
                                    <template v-if="student.studentVerified && student.studentVerified.intensiveSchedule">{{ student.studentVerified.intensiveSchedule.name }}</template>
                                </td>
                                <td v-if="columns.intensiveClassID">
                                    <template v-if="student.studentVerified && student.studentVerified.intensiveClass">{{ student.studentVerified.intensiveClass.name }}</template>
                                </td>
                                <td v-if="columns.placement">
                                    <template v-if="student.studentVerified">{{ student.studentVerified.placement }}</template>
                                </td>
                                <td v-if="columns.payment">
                                    <template v-if="student.studentVerified">{{ student.studentVerified.payment }}</template>
                                </td>
                                <td v-if="columns.paymentNote">
                                    <template v-if="student.studentVerified">{{ student.studentVerified.paymentNote }}</template>
                                </td>

                                <td v-for="profileLabel in profileLabels" v-if="columns[profileLabel]">
                                    <span v-bind:class="{'text-loading': typeof student.additionals[profileLabel] === typeof undefined}">{{ renderCheckBlank(renderProfileLabelValue(student, profileLabel)) }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>
        <b-modal v-model="modal.student" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligibleModified()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload Data Siswa
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="uploadStudent">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-2 align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-student.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-if="profile.isAdmin">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Cabang</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.upload.student.branchID" class="form-control form-control-sm" required>
                                        <option disabled value="" selected>Pilih Cabang...</option>
                                        <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Program</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="branchProgramID" class="form-control form-control-sm">
                                        <option disabled value="" selected>Pilih Program...</option>
                                        <option v-for="branchProgram in branchPrograms" v-bind:value="branchProgram.id" v-bind:key="branchProgram.id">{{ branchProgram.grade.name }} - {{ branchProgram.programType.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Periode</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.upload.student.semester" class="form-control form-control-sm">
                                        <option disabled value="" selected>Pilih Periode...</option>
                                        <option v-for="semester in semesters" v-bind:value="semester.id" v-bind:key="semester.id">{{ semester.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Pola</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <select v-model="form.upload.student.patternID" class="form-control form-control-sm">
                                        <option disabled value="" selected>Pilih Pola...</option>
                                        <option v-for="pattern in patterns" v-bind:value="pattern.id" v-bind:key="pattern.id">{{ patternLabel(pattern) }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-student" type="file" class="form-control" v-on:change="fileUpload($event, 'student', 'student')" placeholder="Choose File" accept=".xlsx, .xls, .csv" required/>
                                    <label for="file-student" class="form-control form-control-sm text-truncate">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button>
                                        {{ form.upload.student.student.name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.student = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.file" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligibleModified()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload File Psikotes
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="uploadFile">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-file" type="file" class="form-control" v-on:change="fileUpload($event, 'file', 'psycho-score')" placeholder="Choose File" required multiple />
                                    <label for="file-file" class="form-control form-control-sm text-truncate">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button>
                                    </label>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-if="form.upload.file['psycho-score'].length">
                                <div class="col">
                                    <ol class="mb-0">
                                        <li v-for="file in form.upload.file['psycho-score']" class="h4 mb-0">{{ file.name }}</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.file = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.score" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligibleModified()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload Nilai Psikotes
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="uploadScore">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-2 align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-psycho-test.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-score" type="file" class="form-control" v-on:change="fileUpload($event, 'score', 'psycho-score')" placeholder="Choose File" accept=".xlsx, .xls, .csv" required />
                                    <label for="file-score" class="form-control form-control-sm text-truncate">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button>
                                        {{ form.upload.score['psycho-score'].name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.score = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.utbk" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligibleModified()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload UTBK
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="uploadUTBK">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-2 align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-utbk.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-utbk" type="file" class="form-control" v-on:change="fileUpload($event, 'utbk', 'nilai-utbk')" placeholder="Choose File" accept=".xlsx, .xls, .csv" required />
                                    <label for="file-utbk" class="form-control form-control-sm text-truncate">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button>
                                        {{ form.upload.utbk['nilai-utbk'].name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.utbk = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-model="modal.photo" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligibleModified()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload Foto Siswa
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="uploadPhoto">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file-photo" type="file" class="form-control" v-on:change="fileUpload($event, 'photo', 'student-images')" placeholder="Choose File" accept="image/*" multiple required />
                                    <label for="file-photo" class="form-control form-control-sm">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button>
                                    </label>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col px-1 text-truncate">
                                    <ol>
                                        <li v-for="file in form.upload.photo['student-images']">{{ file.name }}</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.photo = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { dragscroll } from 'vue-dragscroll';
    import Paginate from 'vuejs-paginate';
    import { semesters } from '@/params.js';

    export default {
        name: "StudentIndex",
        directives: {dragscroll},
        components: {
            Paginate
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        watch: {
            profile() {
                this.fetchBranches();
            },
            term() {
                this.paginate(this.page);
            },
            'form.upload.student.branchID'(branchID) {
                if (branchID) {
                    this.axios.get(process.env.API_URL + '/branch-program', {params: {branchID: branchID}}).then(response => {
                        this.branchPrograms = response.data.data;
                    });
                } else {
                    this.branchPrograms = [];
                }
                this.branchProgramID = '';
            },
            branchProgramID(branchProgramID) {
                if (branchProgramID) {
                    this.axios.get(process.env.API_URL + '/pattern', {params: {branchProgramID: branchProgramID}}).then(response => {
                        this.patterns = response.data.data;
                    });
                } else {
                    this.patterns = [];
                }
                this.form.upload.student.patternID = '';
            }
        },
        data() {
            return {
                form: {
                    search: {
                        branchID: '',
                        keyword: '',
                        gradeID: [],
                        sortColumn: 'identity',
                        sortType: 'asc'
                    },
                    upload: {
                        student: {
                            branchID: '',
                            patternID: '',
                            student: '',
                            semester: ''
                        },
                        file: {'psycho-score': []},
                        score: {'psycho-score': ''},
                        utbk: {'nilai-utbk': ''},
                        photo: {'student-images': []}
                    }
                },
                columns: {
                    username: '', name: true, identity: true, gradeID: true, btaGradeID: true, branchID: true, schoolID: true, email: true,

                    nomor_formulir: false, tempat_lahir: false, tanggal_lahir: false, jenis_kelamin: true, alamat_rumah: false, kode_pos: false, nomor_telp_rumah: false, nomor_hp_siswa: false,
                    nama_ayah: false, nomor_hp_ayah: false, pekerjaan_ayah: false, email_ayah: false, nama_ibu: false, nomor_hp_ibu: false, pekerjaan_ibu: false, email_ibu: false,
                    ukuran_jaket: false, diterima_jalur: false, diterima_univ: false, diterima_prodi: false,
                    SNMPTN_nomor: false, SNMPTN_univ_1: false, SNMPTN_prodi_1: false, SNMPTN_univ_2: false, SNMPTN_prodi_2: false, SNMPTN_univ_3: false, SNMPTN_prodi_3: false,
                    SBMPTN_nomor: false, SBMPTN_univ_1: false, SBMPTN_prodi_1: false, SBMPTN_univ_2: false, SBMPTN_prodi_2: false, SBMPTN_univ_3: false, SBMPTN_prodi_3: false,
                    PPKB_nomor: false, PPKB_univ: false, PPKB_prodi: false,
                    TS_nomor: false, TS_univ: false, TS_prodi: false,
                    IUP_nomor: false, IUP_prodi: false,
                    SIMAK_nomor: false, SIMAK_prodi_1: false, SIMAK_prodi_2: false, SIMAK_prodi_3: false, SIMAK_prodi_4: false, SIMAK_prodi_5: false, SIMAK_prodi_6: false, SIMAK_prodi_7: false,
                    Mandiri_1_nomor: false, Mandiri_1_univ: false, Mandiri_1_prodi: false, Mandiri_2_nomor: false, Mandiri_2_univ: false, Mandiri_2_prodi: false, Mandiri_3_nomor: false, Mandiri_3_univ: false, Mandiri_3_prodi: false,
                    kurikulum_sekolah: false, sekolah_impian_1: false, sekolah_impian_2: false, sekolah_impian_3: false,

                    patternID: false, branchClassID: false, payment: false, paymentNote: false, placement: false, intensiveScheduleID: false, intensiveClassID: false,

                    branchProgramID: false, registeredAt: true
                },
                modal: {student: false, file: false, score: false, utbk: false, photo: false},
                filterShow: false,
                branchProgramID: '',
                pageCount: 0,
                page: 1,
                branches: [],
                patterns: [],
                branchPrograms: [],
                grades: [],
                profileLabels: [],
                semesters: semesters,
                students: [
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}}
                ]
            };
        },
        methods: {
            uploadStudent() {
                var formData = new FormData();
                for (var attribute in this.form.upload.student) {
                    formData.set(attribute, this.form.upload.student[attribute]);
                }
                this.axios.post(process.env.API_URL + '/student/upload', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.student = false;

                        for (var attribute in this.form.upload.student) {
                            this.form.upload.student[attribute] = '';
                        }
                    } else {
                        this.$toastr('warning', response.data.errors.length ? response.data.errors[Object.keys(response.data.errors)[0]][0] : response.data.message, 'Warning');
                    }
                });
            },
            uploadFile() {
                var formData = new FormData();
                for (var attribute in this.form.upload.file) {
                    if (Array.isArray(this.form.upload.file[attribute])) {
                        for (let i = 0; i < this.form.upload.file[attribute].length; i++) {
                            formData.set(attribute + '[' + i + ']', this.form.upload.file[attribute][i]);
                        }
                    } else {
                        formData.set(attribute, this.form.upload.file[attribute]);
                    }
                }
                this.axios.post(process.env.API_URL + '/psycho-score/upload-files', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.file = false;

                        for (var attribute in this.form.upload.file) {
                            this.form.upload.file[attribute] = '';
                        }
                        this.form.upload.file['psycho-score'] = [];
                    } else {
                        this.$toastr('warning', response.data.errors.length ? response.data.errors[Object.keys(response.data.errors)[0]][0] : response.data.message, 'Warning');
                    }
                });
            },
            uploadUTBK() {
                var formData = new FormData();
                for (var attribute in this.form.upload.utbk) {
                    formData.set(attribute, this.form.upload.utbk[attribute]);
                }
                this.axios.post(process.env.API_URL + '/student/upload-utbk-bulk', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.utbk = false;

                        for (var attribute in this.form.upload.utbk) {
                            this.form.upload.utbk[attribute] = '';
                        }
                    } else {
                        this.$toastr('warning', response.data.errors.length ? response.data.errors[Object.keys(response.data.errors)[0]][0] : response.data.message, 'Warning');
                    }
                });
            },
            uploadPhoto() {
                var formData = new FormData();
                for (var attribute in this.form.upload.photo) {
                    if (Array.isArray(this.form.upload.photo[attribute])) {
                        for (let i = 0; i < this.form.upload.photo[attribute].length; i++) {
                            formData.set(attribute + '[' + i + ']', this.form.upload.photo[attribute][i]);
                        }
                    } else {
                        formData.set(attribute, this.form.upload.photo[attribute]);
                    }
                }
                this.axios.post(process.env.API_URL + '/student/upload-images', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.photo = false;

                        for (var attribute in this.form.upload.utbk) {
                            this.form.upload.photo[attribute] = '';
                        }
                        this.form.upload.photo['student-images'] = [];
                    } else {
                        this.$toastr('warning', response.data.errors.length ? response.data.errors[Object.keys(response.data.errors)[0]][0] : response.data.message, 'Warning');
                    }
                });
            },
            uploadScore() {
                var formData = new FormData();
                for (var attribute in this.form.upload.score) {
                    formData.set(attribute, this.form.upload.score[attribute]);
                }
                this.axios.post(process.env.API_URL + '/psycho-score/upload-scores', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.score = false;

                        for (var attribute in this.form.upload.score) {
                            this.form.upload.score[attribute] = '';
                        }
                    } else {
                        this.$toastr('warning', response.data.errors.length ? response.data.errors[Object.keys(response.data.errors)[0]][0] : response.data.message, 'Warning');
                    }
                });
            },
            paginate(page, scroll = true) {
                this.axios.get(process.env.API_URL + '/student', {params: Object.assign({}, this.form.search, {termID: this.term.id, page: page})}).then(response => {
                    this.students = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            fetchBranches() {
                if (this.roleElligibleFilter()) {
                    this.axios.get(process.env.API_URL + '/branch').then(response => {
                        this.branches = response.data.data;
                    });
                }
            },
            guessBranchProgram(student) {
                var branchProgram = {};
                if (student.studentVerified) {
                    if (student.studentVerified.pattern) {
                        branchProgram = student.studentVerified.pattern.branchProgram;
                    } else if (student.studentVerified.intensiveSchedule) {
                        branchProgram = student.studentVerified.intensiveSchedule.branchProgram;
                    }
                }
                return branchProgram;
            },
            fileUpload(event, type, attribute) {
                var input = event.currentTarget;
                let files = input.files;
                if (files && files[0]) {
                    if (Array.isArray(this.form.upload[type][attribute])) {
                        this.form.upload[type][attribute] = [];
                        for (let i = 0; i < files.length; i++) {
                            this.form.upload[type][attribute].push(files[i]);
                        }
                    } else {
                        this.form.upload[type][attribute] = files[0];
                    }
                }
            },
            patternLabel(pattern) {
                return pattern.periods.map(period => {
                    return this.$moment.weekdays(period.day) + ' ' + this.$moment(period.start, "HH:mm:ss").format('HH.mm') + ' - ' + this.$moment(period.end, "HH:mm:ss").format('HH.mm');
                }).join(" | ");
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            renderProfileLabelValue(student, profileLabel) {
                var value = student.additionals[profileLabel];
                if (value) {
                    switch (profileLabel) {
                        default:
                            break;
                    }
                }
                return value;
            },
            renderProfileLabel(profileLabel) {
                switch (profileLabel) {
                    case 'sekolah_impian_1':
                        profileLabel = 'Sekolah/ Universitas 1';
                        break;
                    case 'sekolah_impian_2':
                        profileLabel = 'Sekolah/ Universitas 2';
                        break;
                    case 'sekolah_impian_3':
                        profileLabel = 'Sekolah/ Universitas 3';
                        break;
                    case 'ukuran_jaket':
                        profileLabel = 'Ukuran Kaos/Jaket';
                        break;
                    case 'diterima_jalur':
                        profileLabel = 'Diterima Di Jalur';
                        break;
                    case 'diterima_univ':
                        profileLabel = 'Diterima Di Sekolah/Univ';
                        break;
                    default:
                        break;
                }
                return this.humanize(profileLabel);
            },
            renderCheckBlank(value) {
                return (value !== '' && value !== null) || typeof value === typeof undefined ? value : " ";
            },
            sort(event) {
                var column = event.currentTarget;
                var columnName = column.getAttribute("name");
                if (columnName) {
                    this.form.search.sortType = (this.form.search.sortColumn !== columnName || this.form.search.sortType !== 'asc') ? 'asc' : 'desc';
                    this.form.search.sortColumn = columnName;

                    document.querySelectorAll("table tr th[sort]").forEach(element => {
                        element.removeAttribute("sort");
                    });
                    column.setAttribute("sort", this.form.search.sortType);
                }
                this.paginate(1);
            },
            roleElligibleModified() {
                return this.profile.isAdmin || (this.profile.isEmployee && this.profile.employee.isBranchStaff);
            },
            roleElligibleFilter() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager));
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            }
        },
        created() {
            this.fetchBranches();
            if (this.profile.isEmployee && this.profile.employee.isBranchStaff) {
                this.form.upload.student.branchID = this.profile.employee.branchStaff.branchID;
            }

            this.axios.all([
                this.axios.get(process.env.API_URL + '/grade'),
                this.axios.get(process.env.API_URL + '/student/listAttributes')
            ]).then(this.axios.spread(function (responseGrade, responseProfileLabel) {
                this.grades = responseGrade.data.data;
                this.profileLabels = responseProfileLabel.data.data;
            }.bind(this)));
        },
        mounted() {
            this.paginate(1, false);
            document.title = 'List Student - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active { transition: opacity .5s; }
    .fade-enter, .fade-leave-to { opacity: 0; }

    @media (min-width: 768px) {
        .table-responsive .table td:first-child, .table-responsive .table th:first-child { min-width: 8.2rem;}
        .table-responsive .table td.sticky:nth-child(2), .table-responsive .table th.sticky:nth-child(2) { z-index: 2; left: 8.2rem; top: auto; position: -webkit-sticky; position: sticky; }
    }
</style>


// WEBPACK FOOTER //
// src/components/student/Index.vue